import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';

import * as styles from './FooterLinksList.styles';

export interface Link {
  rel?: string;
  target?: string;
  text: string;
  url: string;
}

interface FooterLinksListProps {
  links: Link[];
  sectionTitle: string;
}

export const FooterLinksList = ({ links, sectionTitle }: FooterLinksListProps) => {
  const { trackLinkClick, trackLinkMouseDown } = useTrackableLink();

  const getTrackingEventWithLabel = (ev: React.MouseEvent<HTMLAnchorElement>) => ({
    event: 'custom_event',
    event_category: 'Footer',
    event_action: `${sectionTitle} click`,
    event_label: ev.currentTarget.textContent?.trim(),
  });

  return (
    <ul css={styles.list}>
      {links.map((link) => (
        <li css={styles.item} key={link.text}>
          <a
            css={styles.link}
            href={link.url}
            onClick={trackLinkClick(getTrackingEventWithLabel)}
            onMouseDown={trackLinkMouseDown(getTrackingEventWithLabel)}
            target={link.target ?? '_self'}
            {...(link.rel && { rel: link.rel })}
          >
            {link.text}
          </a>
        </li>
      ))}
    </ul>
  );
};
